import { Filter, Gauge, Layers, Users, Wrench } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Table, TBody, TD, TH, THead, TR } from '@/components/ui/table'
import { useOverviewReport, usePeriod } from '../api'
import { ReportCard } from '../components/ReportBits'
import { ReportLayout } from '../components/ReportLayout'

export function OverviewReportPage() {
  const { t } = useTranslation()
  const { months } = usePeriod()
  const q = useOverviewReport(months)
  const r = q.data

  return (
    <ReportLayout name="genel" title={t('reports.pages.overview.title')} description={t('reports.pages.overview.subtitle')} query={q}>
      {r ? (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <ReportCard icon={Filter} title={t('reports.sales.funnel')} description={t('reports.sales.funnelHint')}>
            <p className="mb-3 text-sm text-muted-foreground">{t('reports.kpi.winRate')}: %{r.funnel.winRatePercent}</p>
            <Table>
              <THead>
                <TR>
                  <TH>{t('reports.col.stage')}</TH>
                  <TH className="text-right">{t('reports.col.customers')}</TH>
                </TR>
              </THead>
              <TBody>
                {r.funnel.stages.map((s) => (
                  <TR key={s.code || s.name}>
                    <TD>{s.name || s.code}</TD>
                    <TD className="text-right tabular-nums">{s.accounts}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </ReportCard>
          <ReportCard icon={Users} title={t('reports.sales.reps')} description={t('reports.sales.repsHint')}>
            <Table>
              <THead>
                <TR>
                  <TH>{t('reports.col.rep')}</TH>
                  <TH className="text-right">{t('reports.series.won')}</TH>
                  <TH className="text-right">{t('reports.col.winRate')}</TH>
                </TR>
              </THead>
              <TBody>
                {r.reps.map((rep) => (
                  <TR key={rep.userId || rep.name}>
                    <TD>{rep.name}</TD>
                    <TD className="text-right tabular-nums">{rep.won}</TD>
                    <TD className="text-right tabular-nums">%{rep.winRatePercent}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </ReportCard>
          <ReportCard icon={Gauge} title={t('reports.ops.throughput')} description={t('reports.ops.throughputHint')}>
            <Table>
              <THead>
                <TR>
                  <TH>{t('reports.col.type')}</TH>
                  <TH className="text-right">{t('reports.col.tasks')}</TH>
                  <TH className="text-right">{t('reports.col.overdue')}</TH>
                </TR>
              </THead>
              <TBody>
                {r.tasks.columns.map((c) => (
                  <TR key={`${c.board}-${c.columnKey}`}>
                    <TD>{c.columnName || c.columnKey}</TD>
                    <TD className="text-right tabular-nums">{c.tasks}</TD>
                    <TD className="text-right tabular-nums">{c.overdue}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </ReportCard>
          <ReportCard icon={Wrench} title={t('reports.ops.installations')} description={t('reports.ops.installationsHint')}>
            <p className="mb-2 text-sm text-muted-foreground">
              {r.installations.licenseStale} / {r.installations.missingInBinary} / {r.installations.silentOver24h}
            </p>
            <Table>
              <THead>
                <TR>
                  <TH>{t('reports.col.status')}</TH>
                  <TH className="text-right">{t('reports.col.count')}</TH>
                </TR>
              </THead>
              <TBody>
                {r.installations.byEnvironmentStatus.map((row) => (
                  <TR key={`${row.environment}-${row.status}`}>
                    <TD>
                      {row.environment} · {row.status}
                    </TD>
                    <TD className="text-right tabular-nums">{row.installations}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </ReportCard>
          <ReportCard icon={Layers} title={t('reports.ops.byType')} description={t('reports.ops.byTypeHint')}>
            <p className="text-sm">
              {t('reports.col.conversion')}: %{r.demos.conversionRatePercent} · {r.demos.total}
            </p>
            <ul className="mt-2 space-y-1 text-sm">
              {r.demos.byStatus.map((s) => (
                <li key={s.status} className="flex justify-between">
                  <span>{s.status}</span>
                  <span className="tabular-nums">{s.count}</span>
                </li>
              ))}
            </ul>
          </ReportCard>
        </div>
      ) : null}
    </ReportLayout>
  )
}
